import "core-js/modules/es.object.get-own-property-descriptor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class;

import { lock } from '@/util/decorator';
import { request } from './util';
var baseUrl = '//vip.video.qq.com/fcgi-bin/comm_cgi';
var 点播cid = window.setting.点播cid;
var TicketService = (_class = /*#__PURE__*/function () {
  function TicketService() {
    _classCallCheck(this, TicketService);
  }

  _createClass(TicketService, null, [{
    key: "getHasZhiboTicket",
    value: function getHasZhiboTicket(pid) {
      var url = "//vip.video.qq.com/fcgi-bin/comm_cgi?name=spp_pre_authentication_live&cmd=25158&pid=".concat(pid, "&platform=2");
      return request()(url);
    }
  }, {
    key: "getHasDianboTicket",
    value: function getHasDianboTicket() {
      var url = "//vip.video.qq.com/fcgi-bin/comm_cgi?name=get_playable_vid_list&cid=".concat(点播cid);
      return request()(url);
    }
  }, {
    key: "getBuyList",
    value: function getBuyList(activityName) {
      var options = {
        name: 'spp_ChenQingLingList',
        cmd: 2,
        activity_name: activityName,
        detail: 1
      };
      return request({
        retry: 1,
        jsonp: true
      })(baseUrl, options);
    }
  }, {
    key: "getOrderInfo",
    value: function getOrderInfo(orderid) {
      var options = {
        name: 'spp_ChenQingLingList',
        cmd: 1,
        order_id: orderid
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "getOrderState",
    value: function () {
      var _getOrderState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(orderid) {
        var options, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = {
                  name: 'spp_cql_live',
                  cmd: 3,
                  order_id: orderid
                };
                _context.next = 3;
                return request()(baseUrl, options).catch(console.log);

              case 3:
                res = _context.sent;
                return _context.abrupt("return", res ? res.data.state : -1);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getOrderState(_x) {
        return _getOrderState.apply(this, arguments);
      }

      return getOrderState;
    }()
  }, {
    key: "receiveOrder",
    value: function receiveOrder(orderid) {
      var options = {
        name: 'spp_cql_live',
        cmd: 4,
        order_id: orderid
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "getOrderReceiveList",
    value: function getOrderReceiveList(orderid) {
      var options = {
        name: 'spp_ChenQingLingList',
        cmd: 3,
        order_id: orderid
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "getInviteUserInfo",
    value: function getInviteUserInfo(orderid, vuid) {
      var options = {
        name: 'spp_ChenQingLingList',
        cmd: 4,
        order_id: orderid,
        vuid: vuid
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "getTicketMarquee",
    value: function getTicketMarquee() {
      var options = {
        name: 'marquee',
        cmd: 43622
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "getTicketInfo",
    value: function getTicketInfo() {
      var options = {
        name: 'spp_ChenQingLingList',
        cmd: 16
      };
      return request()(baseUrl, options);
    }
  }]);

  return TicketService;
}(), (_applyDecoratedDescriptor(_class, "getHasDianboTicket", [lock], Object.getOwnPropertyDescriptor(_class, "getHasDianboTicket"), _class), _applyDecoratedDescriptor(_class, "getOrderInfo", [lock], Object.getOwnPropertyDescriptor(_class, "getOrderInfo"), _class), _applyDecoratedDescriptor(_class, "getOrderState", [lock], Object.getOwnPropertyDescriptor(_class, "getOrderState"), _class), _applyDecoratedDescriptor(_class, "receiveOrder", [lock], Object.getOwnPropertyDescriptor(_class, "receiveOrder"), _class), _applyDecoratedDescriptor(_class, "getInviteUserInfo", [lock], Object.getOwnPropertyDescriptor(_class, "getInviteUserInfo"), _class), _applyDecoratedDescriptor(_class, "getTicketMarquee", [lock], Object.getOwnPropertyDescriptor(_class, "getTicketMarquee"), _class), _applyDecoratedDescriptor(_class, "getTicketInfo", [lock], Object.getOwnPropertyDescriptor(_class, "getTicketInfo"), _class)), _class);
export default TicketService;